import React, { useState } from "react";
import { Row, Col, Card, Button, Steps, Popover } from "antd";
import TextInput from "../../components/input/TextInput";
import "./Styles.css";
import { EMAIL_REGX } from "../../config/variables";
import { formatToNumber } from "../../config/utils";
import { useDispatch } from "react-redux";
import { AuthAction } from "../../store/actions";

const Register = ({ count, onChangeStep,userData }) => {
  const dispatch = useDispatch();
  const [contactInfo, setInfo] = useState({
    title: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    password: "",
    confirm_password: "",
  });
  const [errors, setErrors] = useState({
    first_nameError: "",
    last_nameError: "",
    emailError: "",
    phoneError: "",
    passwordError: "",
    confirm_passwordError: "",
  });
  const onChangeContactInfo = (e) => {
    setInfo({
      ...contactInfo,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [`${e.target.name}Error`]: "",
    });
  };

  const onSubmit = () => {
    let first_nameError = "";
    let last_nameError = "";
    let phoneError = "";
    let emailError = "";
    let passwordError = "";
    let confirm_passwordError = "";
    if (
      !contactInfo?.first_name.trim().length ||
      !contactInfo?.last_name.trim().length ||
      !contactInfo?.phone.trim().length ||
      !EMAIL_REGX.test(contactInfo.email) ||
      !contactInfo?.password.trim().length ||
      !contactInfo?.confirm_password.trim().length ||
      contactInfo.password !== contactInfo.confirm_password ||
      contactInfo?.password.trim().length < 8
    ) {
      if (!contactInfo?.first_name.trim().length) {
        first_nameError = "First name is required.";
        setErrors({
          ...errors,
          first_nameError,
        });
      }
      if (!contactInfo?.last_name.trim().length) {
        last_nameError = "Last name is required.";
        setErrors({
          ...errors,
          first_nameError,
          last_nameError,
        });
      }
      if (!contactInfo?.phone.trim().length) {
        phoneError = "Phone number is required.";
        setErrors({
          ...errors,
          phoneError,
          first_nameError,
          last_nameError,
        });
      }
      if (!EMAIL_REGX.test(contactInfo.email)) {
        emailError = "Email is required.";
        setErrors({
          ...errors,
          emailError,
          phoneError,
          first_nameError,
          last_nameError,
        });
      }
      if (!contactInfo?.password.trim().length) {
        passwordError = "Password is required.";
        setErrors({
          ...errors,
          emailError,
          phoneError,
          first_nameError,
          last_nameError,
          passwordError,
        });
      }
      if (contactInfo?.password.trim().length < 8) {
        passwordError = "password should be at least 8 characters long. ";
        setErrors({
          ...errors,
          emailError,
          phoneError,
          first_nameError,
          last_nameError,
          passwordError,
        });
      }
      if (!contactInfo?.confirm_password.trim().length) {
        confirm_passwordError = "Confirm password is required.";
        setErrors({
          ...errors,
          emailError,
          phoneError,
          first_nameError,
          last_nameError,
          passwordError,

          confirm_passwordError,
        });
      }

      if (contactInfo.password !== contactInfo.confirm_password) {
        confirm_passwordError = "mismatch password";
        setErrors({
          ...errors,
          emailError,
          phoneError,
          first_nameError,
          last_nameError,
          passwordError,
          confirm_passwordError,
        });
      }
      return;
    }

    dispatch(AuthAction.SignUp(contactInfo));
  };

  const {
    first_nameError,
    last_nameError,
    phoneError,
    emailError,
    passwordError,
    confirm_passwordError,
  } = errors;
  const { Step } = Steps;
  const customDot = (dot, { status, index }) => (
    <Popover
      content={
        <span>
          step {index} status: {status}
        </span>
      }
    >
      {dot}
    </Popover>
  );

  return (
    <Row justify="center">
      <Col xs={24} sm={24} md={24} xl={24} lg={24}>
        <Card
          style={{
            boxShadow: 'boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px',
          }}
        >
          <Steps current={count} progressDot={customDot}>
            <Step title="Register" />
            <Step title="Create Profile" />
            <Step title="Add your plant" />
            <Step title="Personlize" />
            <Step title="Build Catalog" />
            <Step title="Subscription" />
          </Steps>
          <Col className="login-card">
            <h2 className="text-left">Contact Information</h2>
          </Col>
          <Row justify="center">
            <Col
              xs={24}
              sm={24}
              md={24}
              xl={12}
              lg={12}
              className="cardpadding"
            >
              <Row>
                <Col span={24}>
                  <TextInput
                    label={"Title"}
                    name="title"
                    onChange={onChangeContactInfo}
                    value={contactInfo.title}
                  />
                </Col>
                <Col span={24}>
                  <TextInput
                    label={"First Name"}
                    required
                    name="first_name"
                    onChange={onChangeContactInfo}
                    value={contactInfo.first_name}
                  />
                  <Row justify="end">
                    <Col span={24} className="text-right">
                      {" "}
                      <span className="danger-color text-right">
                        {first_nameError && first_nameError}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <TextInput
                    label={"Last Name"}
                    required
                    name="last_name"
                    onChange={onChangeContactInfo}
                    value={contactInfo.last_name}
                  />
                  <Row justify="end">
                    <Col span={24} className="text-right">
                      {" "}
                      <span className="danger-color text-right">
                        {last_nameError && last_nameError}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <TextInput
                    label={"Phone Number"}
                    required
                    name="phone"
                    onChange={onChangeContactInfo}
                    value={formatToNumber(contactInfo.phone)}
                  />
                  <Row justify="end">
                    <Col span={24} className="text-right">
                      {" "}
                      <span className="danger-color text-right">
                        {phoneError && phoneError}
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={24}
              xl={12}
              lg={12}
              className="cardpadding logincardStyling"
            >
              <Col className="login-card">
                <h2 className="text-left">Login Credentials</h2>
              </Col>
              <Row>
                <Col span={24}>
                  <TextInput
                    label={"Email Address"}
                    required
                    name="email"
                    onChange={onChangeContactInfo}
                    value={contactInfo.email}
                  />
                  <Row justify="end">
                    <Col span={24} className="text-right">
                      {" "}
                      <span className="danger-color text-right">
                        {emailError && emailError}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <TextInput
                    label={"Password"}
                    required
                    type="password"
                    name="password"
                    onChange={onChangeContactInfo}
                    value={contactInfo.password}
                  />
                  <Row justify="end">
                    <Col span={24} className="text-right">
                      {" "}
                      <span className="danger-color text-right">
                        {passwordError && passwordError}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <TextInput
                    label={"Confirm Password"}
                    required
                    type="password"
                    name="confirm_password"
                    onChange={onChangeContactInfo}
                    value={contactInfo.confirm_password}
                  />
                  <Row justify="end">
                    <Col span={24} className="text-right">
                      {" "}
                      <span className="danger-color text-right">
                        {confirm_passwordError && confirm_passwordError}
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
        <Col xs={23} sm={20} md={24} xl={24} lg={24}>
          <h3
            style={{
              color: "#ff9800",
              marginTop: "10px",
              alignItems: "center",
            }}
          >
            Already started sign-up process?{" "}
            <span style={{ fontWeight: "600" }}>Continue from here </span>
          </h3>
        </Col>
        <Row justify="end">
          <Col xs={24} sm={24} md={10} lg={8} xl={6}>
            <Button
              style={{
                backgroundColor: "#ff9800",
                color: "#fff",
                width: "50%",
              }}
              onClick={() => onSubmit()}
            >
              CREATE PROFILE
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Register;
